<div class="materials-page">

  <!-- Migration Dialog for Speaking of Speech redirect -->
  <div class="migration-overlay" *ngIf="showMigrationBanner">
    <div class="migration-card">
      <h1>Welcome! Speaking of Speech has moved.</h1>
      <p>All Speaking of Speech materials are now part of <strong>EDU Healthcare's</strong> Resource Library. Browse and enjoy!</p>
      <button class="migration-btn" (click)="dismissMigrationBanner()">Got it</button>
    </div>
  </div>

  <!-- Search & Filter Section -->
  <div class="search-section">
    <div class="search-section-inner">
      <div class="search-header">
        <h1 class="page-title">EDU Healthcare Resource Library</h1>
        <p class="page-subtitle">Browse therapy resources, visual supports, and educational materials</p>
      </div>

      <div class="search-bar-row">
        <div class="search-input-wrapper">
          <i class="material-icons search-icon">search</i>
          <input type="text" class="search-input" placeholder="Search by title or keyword..." [(ngModel)]="searchParams.searchText" name="searchText" (keyup.enter)="doSearch()" />
          <button *ngIf="searchParams.searchText" class="clear-search-btn" (click)="searchParams.searchText = ''; doSearch()">
            <i class="material-icons">close</i>
          </button>
        </div>

        <div class="filter-controls-row">
          <div class="select-wrapper">
            <mat-form-field class="filter-select no-subscript" appearance="outline">
              <mat-label>Category</mat-label>
              <mat-select [(ngModel)]="searchParams.categories" name="categories" (selectionChange)="checkForSubs($event.value)">
                <mat-option value="">All Categories</mat-option>
                <mat-option *ngFor="let category of materialCategories" [value]="category?.name">
                  {{ category?.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="select-wrapper" *ngIf="showSubCategorySelect && subCategoryToShow">
            <mat-form-field class="filter-select no-subscript" appearance="outline">
              <mat-label>Sub Category</mat-label>
              <mat-select [(ngModel)]="searchParams.subCategories" name="subCategories">
                <mat-option value="">All Sub Categories</mat-option>
                <mat-option *ngFor="let subCategory of subCategoryToShow?.subCategories" [value]="subCategory.name">
                  {{ subCategory?.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="action-buttons">
            <button class="btn-filter" (click)="doSearch()">
              <i class="material-icons">filter_list</i>
              <span>Filter</span>
            </button>
            <button class="btn-clear" (click)="clearFilter()" *ngIf="hasCurrentAdvancedSearchParams()">
              <i class="material-icons">clear_all</i>
              <span>Clear</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Active filter chips -->
      <div class="active-filters" *ngIf="hasCurrentAdvancedSearchParams()">
        <span class="active-filter-label">Active filters:</span>
        <span class="filter-chip" *ngIf="searchParams.searchText">
          <i class="material-icons chip-icon">search</i>
          "{{ searchParams.searchText }}"
          <i class="material-icons chip-close" (click)="searchParams.searchText = ''; doSearch()">close</i>
        </span>
        <span class="filter-chip" *ngIf="searchParams.categories">
          <i class="material-icons chip-icon">folder</i>
          {{ searchParams.categories }}
          <i class="material-icons chip-close" (click)="searchParams.categories = ''; searchParams.subCategories = ''; showSubCategorySelect = false; subCategoryToShow = null; doSearch()">close</i>
        </span>
        <span class="filter-chip" *ngIf="searchParams.subCategories">
          <i class="material-icons chip-icon">subdirectory_arrow_right</i>
          {{ searchParams.subCategories }}
          <i class="material-icons chip-close" (click)="searchParams.subCategories = ''; doSearch()">close</i>
        </span>
      </div>
    </div>
  </div>

  <!-- Toolbar Row -->
  <div class="toolbar-row">
    <div class="toolbar-left">
      <span class="results-count" *ngIf="totalItemsCount > 0">{{ totalItemsCount }} material{{ totalItemsCount !== 1 ? 's' : '' }} found</span>
      <span class="results-count" *ngIf="totalItemsCount === 0 && !isLoadingResults">No materials found</span>
    </div>
    <div class="toolbar-right">
      <div class="view-toggle desktop-only">
        <button class="toggle-btn" [class.active]="currentViewMode === '4 Columns'" (click)="setViewType('4 Columns')" matTooltip="Grid View" matTooltipPosition="above">
          <i class="material-icons">grid_view</i>
        </button>
        <button class="toggle-btn" [class.active]="currentViewMode === 'List View'" (click)="setViewType('List View')" matTooltip="List View" matTooltipPosition="above">
          <i class="material-icons">view_list</i>
        </button>
      </div>
      <button *ngIf="isAdmin" class="btn-create" (click)="showAddMaterialDialog()">
        <i class="material-icons">add</i>
        <span>Create Material</span>
      </button>
    </div>
  </div>

  <!-- Content Area -->
  <div class="content-area">

    <!-- Loading State -->
    <div class="loading-overlay" *ngIf="isLoadingResults">
      <mat-spinner diameter="48"></mat-spinner>
      <p class="loading-text">Loading materials...</p>
    </div>

    <!-- Grid View -->
    <div class="materials-grid" *ngIf="!isLoadingResults && currentViewMode === '4 Columns' && allMedia?.length">
      <div class="grid-item" *ngFor="let item of allMaterials | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: totalItemsCount }; let i = index;">
        <material-card *ngIf="!item?.adToDisplay" [item]="item"></material-card>
      </div>

      <nav class="grid-pagination" aria-label="Page navigation">
        <pagination-controls class="paginationController" (pageChange)="changeThePage($event)" previousLabel="Previous" nextLabel="Next"></pagination-controls>
      </nav>
    </div>

    <!-- List View -->
    <div class="materials-list" *ngIf="!isLoadingResults && currentViewMode === 'List View' && allMedia?.length">
      <div class="table-wrapper">
        <table mat-table id="view-material-table" class="materials-table" [dataSource]="allMedia" matSort>
          <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Title</mat-header-cell>
            <mat-cell *matCellDef="let material">
              <div class="table-title-text">{{ material?.title }}</div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="categories">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Categories</mat-header-cell>
            <mat-cell *matCellDef="let material">
              <div class="table-categories">
                <span *ngFor="let _cat of material.categories; let i = index" class="table-cat-chip">
                  {{ _cat?.name }}
                </span>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="sub-categories">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Sub Categories</mat-header-cell>
            <mat-cell *matCellDef="let material">
              <div class="table-categories">
                <span *ngFor="let _cat of material.categories; let i = index" class="table-subcat-chip">
                  {{ _cat?.subCategory }}
                </span>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="view">
            <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
            <mat-cell *matCellDef="let material">
              <button class="table-view-btn" (click)="showMaterialDetail(material)">
                View
                <i class="material-icons">arrow_forward</i>
              </button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let material; columns: displayedColumns;" (click)="showMaterialDetail(material)"></mat-row>
        </table>

        <mat-paginator showFirstLastButtons [pageSize]="defaultPageSize" [length]="totalItemsCount" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!isLoadingResults && !allMedia?.length">
      <div class="empty-state-content">
        <i class="material-icons empty-icon">library_books</i>
        <h3>No materials found</h3>
        <p>Try adjusting your filters or search terms to find what you're looking for.</p>
        <button class="btn-clear-empty" *ngIf="hasCurrentAdvancedSearchParams()" (click)="clearFilter()">
          <i class="material-icons">refresh</i>
          Clear all filters
        </button>
      </div>
    </div>
  </div>
</div>
